<div class="rounded-2xl bg-white p-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]">
<ng-content />
@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    title="Something went wrong"
    i18n-title="@@adminApprovedPhError"
    [showRetry]="true"
    (retry)="pageChange.emit(currentPage())" />
}
@if (state() === "success") {
  <app-tables
    [headerItems]="headerItems()"
    [keyboardNavigation]="view() === 'telesales'"
    (rowShift)="onRowShift($event)"
    [rows]="rows()!"
    (toggleDropdown)="toggleDropdown($event)"
    [currentActions]="currentActions()"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="emptyFilterTitle()"
    [emptyContentTitle]="emptyContentTitle()" />
}
</div>

@if (state() === "success") {

  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPreviousPage()"
    (nextPage)="onNextPage()"
    (goToPage)="onGoToPage($event)"
    (changePageNumber)="onChangePageNumber($event)"
    (pageSizeChange)="onPageSizeChange()" />
}

<!-- <div class="mt-2 overflow-visible rounded-[8px] border border-[#E5E7EB] bg-white shadow-sm">
  <table class="w-full text-left text-sm text-gray-500">
    <thead class="bg-[#F3F4F6] text-xs font-[600] text-[#374151] uppercase">
      <tr>
        <th class="px-6 py-3 text-center" i18n="@@adminApprovedPhNickname">Pharmacy Nickname</th>
        <th class="px-6 py-3 text-center" i18n="@@adminApprovedPhOwner">Pharmacy Owner</th>
        <th
          class="px-6 py-3 text-center"
          *hasScope="SCOPES.PHARMACIES.AUTO_COMPLETE_BY_EMPLOYEE_NAME"
          i18n="@@adminApprovedPhAssignedTo">
          Assigned To
        </th>
        <th class="px-6 py-3 text-center" i18n="@@adminApprovedPhCredit">Pharmacy Credit</th>
        <th class="px-6 py-3 text-center" i18n="@@adminApprovedPhSegment">Pharmacy Segment</th>
        <th class="px-6 py-3 text-center" i18n="@@adminApprovedPhCreatedOn">Created On / By</th>
        <th class="px-6 py-3 text-center" i18n="@@adminApprovedPhLastModified">Last Modified On / By</th>
        <th class="px-6 py-3 text-center"></th>
      </tr>
    </thead>
    <tbody>
      @if (state() === "loading") {
        <tr>
          <td colspan="7" class="p-8 text-center">
            <app-loading />
          </td>
        </tr>
      } @else if (state() === "error") {
        <tr>
          <td colspan="7" class="p-8 text-center">
            <app-error-data
              title="Something went wrong"
              i18n-title="@@adminApprovedPhError"
              [showRetry]="true"
              (retry)="pageChange.emit(currentPage())"></app-error-data>
          </td>
        </tr>
      } @else {
        @if (pharmacies()?.length === 0) {
          <tr>
            <td colspan="7" class="p-8 text-center">
              @if (isFiltersApplied()) {
                <app-empty-data
                  title="No pharmacies match your criteria."
                  i18n-title="@@adminApprovedPhNoFilterResults"></app-empty-data>
              } @else {
                <app-empty-data
                  title="No Pharmacies Found"
                  i18n-title="@@adminApprovedPhNoDataTitle"
                  description="No approved pharmacies in the system."
                  i18n-description="@@adminApprovedPhNoDataSub"></app-empty-data>
              }
            </td>
          </tr>
        } @else {
          @for (pharmacy of pharmacies(); track pharmacy.id) {
            <tr
              (click)="rowClick.emit(pharmacy.id)"
              class="cursor-pointer border-b border-[#E5E7EB] bg-white hover:bg-gray-50">
              <td class="px-6 py-4 text-center text-[13px] font-[500] text-gray-900">
                {{ pharmacy.nickName.length > 20 ? pharmacy.nickName.slice(0, 25) + "...." : pharmacy.nickName }}
              </td>
              <td class="px-6 py-4 text-center text-[13px] text-gray-900">
                {{ pharmacy.pharmacyOwner.fullName }}
              </td>
              <td
                *hasScope="SCOPES.PHARMACIES.AUTO_COMPLETE_BY_EMPLOYEE_NAME"
                class="px-6 py-4 text-center text-[13px] text-gray-900">
                {{ pharmacy.teleSalesEmployee?.fullName || "—" }}
              </td>
              <td class="px-6 py-4 text-center text-[13px] text-gray-900">
                {{ pharmacy.pharmacyCredit | number: "1.0-0" }} {{ isArabic() ? "ج.م" : "EGP" }}
              </td>
              <td class="px-6 py-4 text-center text-[13px] text-gray-900">
                {{ isArabic() ? pharmacy.pharmacySegment.titleAr : pharmacy.pharmacySegment.titleEn }}
              </td>
              <td class="px-6 py-4 text-center text-[12px] text-[#6B7280]">
                <span class="block">{{ pharmacy.createdOn | date }}</span>
                <span>{{ pharmacy.createdBy.fullName }}</span>
              </td>
              <td class="px-6 py-4 text-center text-[12px] text-[#6B7280]">
                @if (pharmacy.lastModifiedOn) {
                  <span class="block">{{ pharmacy.lastModifiedOn | date }}</span>
                  <span>{{ pharmacy.lastModifiedBy?.fullName }}</span>
                } @else {
                  <span>—</span>
                }
              </td>
              <td
                class="relative flex items-center justify-center px-6 py-4 pr-9 text-center"
                (click)="$event.stopPropagation()">
                <div class="inline-flex items-center justify-center">
                  <button
                    (click)="openDropdown($event, pharmacy)"
                    class="flex h-[28px] w-[28px] items-center justify-center rounded-[6px] text-gray-600 hover:cursor-pointer hover:bg-[#E5E7EB] hover:text-gray-900">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <circle cx="12" cy="12" r="1"></circle>
                      <circle cx="12" cy="5" r="1"></circle>
                      <circle cx="12" cy="19" r="1"></circle>
                    </svg>
                  </button>

                  @if (activeDropdownId() === pharmacy.id) {
                    <div class="fixed inset-0 z-40" (click)="closeDropdown()"></div>
                    <div
                      [class.ltr:right-0]="true"
                      [class.rtl:left-0]="true"
                      class="absolute top-full z-50 mt-1 w-44 rounded-md border border-gray-200 bg-white p-1 shadow-lg">
                      <button
                        (click)="onViewDetails($event, pharmacy)"
                        class="flex w-full items-center gap-2 rounded-[4px] px-3 py-2 text-left text-[13px] text-gray-700 hover:bg-gray-50">
                        <span i18n="@@actionViewDetails">View Pharmacy Details</span>
                      </button>

                      <button
                        (click)="onAssign($event, pharmacy)"
                        class="flex w-full items-center gap-2 rounded-[4px] px-3 py-2 text-left text-[13px] text-gray-700 hover:bg-gray-50">
                        @if (isUnassigned(pharmacy)) {
                          <span *hasScope="SCOPES.PHARMACIES.ASSIGN_TELESALES" i18n="@@actionAssignTeleSales">
                            Assign Tele Sales
                          </span>
                        } @else {
                          <span *hasScope="SCOPES.PHARMACIES.ASSIGN_TELESALES" i18n="@@actionReassignTeleSales">
                            Re-assign Tele Sales
                          </span>
                        }
                      </button>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        }
      }
    </tbody>
  <!-- </table>
</div>

-- !> -->

@if (showAssignDialog() && selectedPharmacy()) {
  <app-assign-employee-dialog
    [pharmacyId]="selectedPharmacy()!.id"
    [nickname]="selectedPharmacy()!.nickName"
    [type]="isUnassigned(selectedPharmacy()!) ? 'assign' : 're-assign'"
    [prevEmployeeId]="selectedPharmacy()!.teleSalesEmployee?.id"
    [autoCompleteFn]="autoCompleteFn"
    [submitFn]="submitFn"
    context="approved-pharmacy"
    (close)="onAssignDialogClose()"
    (employeeAssign)="onAssignDialogSuccess($event)"></app-assign-employee-dialog>
}
